import { useLayout } from '@bonanza-social/moonlight';
import { useMemo } from 'react';
import { StatusResponseType } from '../state';

type UseProgressPercentParams = {
  accumulatedLoyaltyPoints:
    | StatusResponseType['accumulatedLoyaltyPoints']
    | undefined;
  totalLoyaltyPoints: StatusResponseType['totalLoyaltyPoints'] | undefined;
  imageOffset?: number;
};

const useProgressPercent = ({
  accumulatedLoyaltyPoints,
  totalLoyaltyPoints,
  imageOffset = 0,
}: UseProgressPercentParams) => {
  const [barLayout, onBarLayout] = useLayout();
  const [percentLayout, onPercentLayout] = useLayout();

  const percentX = useMemo(() => {
    if (
      barLayout.width &&
      percentLayout.width &&
      accumulatedLoyaltyPoints !== undefined &&
      totalLoyaltyPoints !== undefined
    ) {
      const currentProgress = accumulatedLoyaltyPoints / totalLoyaltyPoints;
      const progressWidth = barLayout.width * currentProgress;

      if (progressWidth > barLayout.width - imageOffset) {
        return -(progressWidth - (barLayout.width - imageOffset));
      } else if (
        progressWidth + percentLayout.width <
        barLayout.width - imageOffset
      ) {
        return percentLayout.width;
      }
    }

    return 0;
  }, [
    barLayout,
    percentLayout,
    accumulatedLoyaltyPoints,
    totalLoyaltyPoints,
    imageOffset,
  ]);

  return {
    onBarLayout,
    onPercentLayout,
    percentX,
  };
};

export default useProgressPercent;
